// components/reviews/reviewPanes.js
"use client";
import React from "react";
import { Tab, Grid, Dropdown, Segment } from "semantic-ui-react";
import {
  CommentList,
  NewDescription,
  EditorDescription,
} from "../../../common/index.js";
import { NewWcomment } from "../../../components/index.js";

export function getEditorPanes(
  state,
  handlers,
  sortbyoptions,
  data,
  revs,
  comment,
  like,
  sortbyeditoroptions,
) {
  return [
    {
      menuItem: `All (${state.allcount})`,
      render: () => (
        <Tab.Pane attached={false}>
          <Segment>
            <Grid>
              <Grid.Column width={8}></Grid.Column>
              <Grid.Column width={8} textAlign="right">
                <span>
                  Sort By:{" "}
                  <Dropdown
                    inline
                    options={sortbyoptions}
                    defaultValue={sortbyoptions?.[0]?.value || ""}
                    onChange={handlers.handlesortby}
                  />
                </span>
              </Grid.Column>
            </Grid>
          </Segment>
          <NewDescription
            desData={state.nhreviews}
            display={data}
            showMore={revs}
            show={handlers.onShow}
            visibility={comment}
            click={handlers.onReviews}
            toggle={handlers.onComment}
            change={handlers.askQues}
            like={like}
            onLike={handlers.onLike}
            review={
              state.is_editor ? handlers.onEditorreview : handlers.onReview
            }
            showeditbutton={state.showeditbutton}
            onRate={handlers.onRate}
            is_display_review_txt={state.is_display_review_txt}
            is_change_review_txt={state.is_change_review_txt}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: `Pending (${state.pendingcount})`,
      render: () => (
        <Tab.Pane attached={false}>
          <Segment>
            <Grid>
              <Grid.Column width={8}></Grid.Column>
              <Grid.Column width={8} textAlign="right">
                <span>
                  Sort By:{" "}
                  <Dropdown
                    inline
                    options={sortbyoptions}
                    defaultValue={sortbyoptions[0].value}
                    onChange={handlers.handlesortby}
                  />
                </span>
              </Grid.Column>
            </Grid>
          </Segment>
          <NewDescription
            desData={state.pendingreview}
            display={data}
            showMore={revs}
            show={handlers.onShow}
            visibility={comment}
            click={handlers.onReviews}
            toggle={handlers.onComment}
            change={handlers.askQues}
            like={like}
            onLike={handlers.onLike}
            review={handlers.onReview}
            showeditbutton={true}
            onRate={handlers.onRate}
            is_display_review_txt={state.is_display_review_txt}
            is_change_review_txt={state.is_change_review_txt}
          />
        </Tab.Pane>
      ),
    },
  ];
}

export function getPanes(
  state,
  handlers,
  sortbyoptions,
  data,
  revs,
  comment,
  like,
  sortbyeditoroptions,
) {
  console.log("sortbyoptions", sortbyoptions);
  return [
    {
      menuItem: `All (${state.allcount})`,
      render: () => (
        <Tab.Pane attached={false}>
          <Segment>
            <Grid>
              <Grid.Column width={8}></Grid.Column>
              <Grid.Column width={8} textAlign="right">
                <span>
                  Sort By:{" "}
                  <Dropdown
                    inline
                    options={sortbyoptions}
                    defaultValue={sortbyoptions[0].value}
                    onChange={handlers.handlesortby}
                  />
                </span>
              </Grid.Column>
            </Grid>
          </Segment>
          <NewDescription
            desData={state.nhreviews}
            display={data}
            showMore={revs}
            show={handlers.onShow}
            visibility={comment}
            click={handlers.onReviews}
            toggle={handlers.onComment}
            change={handlers.askQues}
            like={like}
            onLike={handlers.onLike}
            review={handlers.onReview}
            showeditbutton={state.showeditbutton}
            onRate={handlers.onRate}
            is_display_review_txt={state.is_display_review_txt}
            is_change_review_txt={state.is_change_review_txt}
          />
        </Tab.Pane>
      ),
    },
  ];
}

export function getReviewQuesPanes(
  state,
  handlers,
  data,
  revs,
  comment,
  like,
  reply,
  ques,
  qlike,
  rlike,
  replies,
  askque,
  onquestion,
  sortbyoptions,
  sortbyeditoroptions,
) {
  return [
    {
      menuItem: "Houseberry's Take",
      render: () => (
        <Tab.Pane attached={false} active>
          <EditorDescription
            desData={state.houseberrytakereview}
            isEditor={state.is_editor}
            review={handlers.onEditorreview}
            userId={state.userId}
            onEditreview={handlers.onEditreview}
            onDeletereview={handlers.onDeletereview}
            cityname={state.nhdetails[0].census_name}
            statename={state.nhdetails[0].state_name}
            cityfullname={state.nhdetails[0].cityfullname}
            isnh={true}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: `Comments (${state.allcount})`,
      render: () => (
        <Tab.Pane attached={false} active>
          <div
            className={`review_sec_tab ${state.showeditbutton ? "editor_sec" : "all_sec_review"}`}
          >
            <Tab
              menu={{ text: true }}
              panes={
                state.showeditbutton
                  ? getEditorPanes(
                      state,
                      handlers,
                      sortbyeditoroptions,
                      data,
                      revs,
                      comment,
                      like,
                    )
                  : getPanes(
                      state,
                      handlers,
                      sortbyoptions,
                      data,
                      revs,
                      comment,
                      like,
                      sortbyeditoroptions,
                    )
              }
              defaultActiveIndex={0}
            />
          </div>
        </Tab.Pane>
      ),
    },
    {
      menuItem: `Questions (${state.questions.length})`,
      render: () => (
        <Tab.Pane attached={false} active>
          <CommentList
            name="onreply"
            commentData={state.questions}
            visibility={reply}
            toggle={handlers.onReply}
            display={ques}
            click={handlers.onQuestions}
            change={handlers.askQues}
            show={replies}
            replies={handlers.onReplies}
            queslike={qlike}
            rplylike={rlike}
            onLike={handlers.onLike}
            changeval={handlers.askreply}
            submit={(e) => handlers.onReplySubmit(e)}
            value={state.values}
            totstate={state}
            askques={handlers.askquestion}
          />
          <Segment className="question_segment">
            {askque ? (
              <div className="question_section">
                <NewWcomment
                  name="onquestion"
                  form="question"
                  visibility={true}
                  changeval={handlers.askQues}
                  submit={handlers.onSubmit}
                  value={onquestion}
                  buttonName="Ask"
                  placeholder="Ask a Question ..."
                  userimage={
                    state?.user_info && state?.user_info?.length > 0 
                      ? state?.user_info?.[0]?.userimage || ""
                      : ""
                  }
                  askques={handlers.askquestion}
                />
              </div>
            ) : null}
          </Segment>
        </Tab.Pane>
      ),
    },
  ];
}
